import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type SaaSDashboard } from '../../api/saas';

export function TenantHealthPage() {
  const [dashboard, setDashboard] = useState<SaaSDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void saasApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Tenant Health</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard?.platform_health && (
        <div className="mt-4 grid gap-2 sm:grid-cols-2">
          {dashboard.platform_health.map((p) => (
            <div key={p.module} className="rounded-lg border px-3 py-2 text-sm dark:border-slate-700">
              <span className="font-medium">{p.module}</span>
              <span className={`ml-2 capitalize ${p.status === 'healthy' ? 'text-green-600' : 'text-yellow-600'}`}>{p.status}</span>
              {p.latency_ms > 0 && <span className="ml-2 text-slate-500">{p.latency_ms}ms</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
